export default __webpack_public_path__ + "static/media/equipments-footer-logo.418feb17.png";